import React, { useContext, useState } from 'react';
import { Text, View, Pressable } from 'react-native';
import { useQuery, useMutation, useSubscription } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import AuthContext from 'app/src/contexts/AuthContext';
import * as colors from 'app/src/styles/colors';
import Modal from 'app/src/elements/Modal';

import Notification from './show';
import {
  CURRENT_USER_NOTIFICATIONS,
  USER_NOTIFICATION_UPDATED,
  UPDATE_ALL_USER_NOTIFICATIONS,
} from './queries';

const Container = styled(View)`
  position: relative;
`;

const CountContainer = styled(View)`
  position: absolute;
  left: 30px;
  top: 10px;
`;

const UnviewedCount = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.elRed};
`;

const MarkAll = styled(View)`
  flex-direction: row;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 20px;
`;

const Notifications = ({ user }) => {
  const [showModal, setShowModal] = useState(false);
  const { apolloClient: client } = useContext(AuthContext);

  const variables = { sellerUserId: user.id };

  const { data } = useQuery(CURRENT_USER_NOTIFICATIONS, { variables });

  const [updateAllUserNotifications] = useMutation(
    UPDATE_ALL_USER_NOTIFICATIONS
  );

  const markAll = (field, confirmation) => {
    if (!confirmation || confirm(confirmation)) {
      updateAllUserNotifications({ variables: { [field]: true } });
    }
  };

  useSubscription(USER_NOTIFICATION_UPDATED, {
    variables,
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!data || !data.userNotificationUpdated) return;

      const updatedUserNotification =
        data.userNotificationUpdated.userNotification;

      const { currentUserNotifications } = client.readQuery({
        query: CURRENT_USER_NOTIFICATIONS, variables
      });

      const updatedUserNotifications = [
        ...(currentUserNotifications || []).filter(userNotification => (
          updatedUserNotification.id !== userNotification.id
        )),
        updatedUserNotification
      ];

      client.writeQuery({
        query: CURRENT_USER_NOTIFICATIONS,
        variables,
        data: { currentUserNotifications: updatedUserNotifications },
      });
    }
  });

  const visible = (data?.currentUserNotifications || []).
    filter(notification => !notification.hiddenAt).
    toSorted((a, b) => b.notification.id - a.notification.id);

  const unviewed = visible.filter(notification => !notification.viewedAt);
  const unviewedCount = unviewed?.length;

  return (
    <>
      <Container>
        <FontAwesomeIcon
          icon={faBell}
          size='2xl'
          style={{color: unviewedCount ? colors.elRed : colors.iconGray}}
          onClick={() => setShowModal(!showModal)}
        />
        {unviewedCount > 0 &&
          <CountContainer>
            <UnviewedCount>{unviewedCount}</UnviewedCount>
          </CountContainer>
        }
      </Container>
      {showModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          modalType="Notifications"
        >
          <MarkAll>
            <Pressable onPress={() => markAll('viewed')}>
              <Text>Mark All Viewed</Text>
            </Pressable>

            <Pressable onPress={() => markAll('hidden', 'Really dismiss all?')}>
              <Text>Dismiss All</Text>
            </Pressable>
          </MarkAll>

          {visible.map(userNotification => (
            <Notification
              key={userNotification.id}
              userNotification={userNotification}
              setShowModal={setShowModal}
            />
          ))}
        </Modal>
      )}
    </>
  );
};

export default Notifications;
